// extracted by mini-css-extract-plugin
export default {"container":"d1At","header":"lh1O","loader":"hTnN","dragNdrop":"Q61S","drag":"E4hJ","leave":"CJ0t","dragTitle":"_keQ","text":"XGrY","fileLoader":"LmtN"};